import React from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { connect } from "react-redux";

import "react-dates/initialize";
import 'react-dates/lib/css/_datepicker.css';

import { SingleDatePicker } from "react-dates";

import { commonErr } from "../../common/errors";
import { formatTime, getBookingTimes, convertToHourText } from "../../common/common";
import {START_DATE, HORIZONTAL_ORIENTATION } from "../../../constant/constant";

import {
	getEndDatewd
} from "../../common/wdfunction";

const bookingTimes = getBookingTimes();


class CalendarWD extends React.Component { 

	constructor(props) {
		super(props)
		this.state = {

			focusedInput: null,
			// swiperST: null,
			// swiperET: null,
			isDropdownST: false,
			isDropdownET: false
		}
	}

	componentDidMount() {

		this.setState({
			startDate: this.props.startDate,
			endDate: this.props.endDate,
			startTime: this.props.startTime,
			endTime: this.props.endTime
		})

		if (this.props.appInit.err === commonErr.SUCCESS && this.props.appInit.data) { 
			this.setState({
				minDate: this.props.appInit.data.startDate,
				maxDate: this.props.appInit.data.endDate
			})
		}
	
	}


	componentDidUpdate(preProps) {		
		if (preProps.endDate && this.props.endDate) {
		
            if (preProps.endDate.valueOf() !== this.props.endDate.valueOf()) {

			
                this.setState({
                    endDate: this.props.endDate,
                    endTime: this.props.endTime
                })
            }
        }

		if (this.state.isDropdownST) {
			if (document.getElementById(`wst${this.state.startTime}`) !== null) {
				const target = document.getElementById(`wst${this.state.startTime}`);
				target.scrollIntoView({ behavior: "smooth" });
			}
		}
		if (this.state.isDropdownET && this.state.endTime >= 0) {
			if (document.getElementById(`wet${this.state.endTime}`) !== null) {
				const targetET = document.getElementById(`wet${this.state.endTime}`);
				targetET.scrollIntoView({ behavior: "smooth" });
			}
		}

		if (preProps.appInit.err !== this.props.appInit.err) {
			if (this.props.appInit.err === commonErr.SUCCESS && this.props.appInit.data) { 
				this.setState({
					minDate: this.props.appInit.data.startDate,
					maxDate: this.props.appInit.data.endDate
				})
			}
		}

	}

	onHandleDropdown = (name) => {
		this.setState({
			[`${name}`]: true,
		});
	}

	onCloseDropdown = (name) => {
		this.setState({
			[`${name}`]: false,
		});
	}

    onStartDateChange = (date) => {

		this.setState({
			startDate: date,
		})
		this.props.onStartDateChange(date);
	};

	onDatesChange = (date) => {
		this.props.onDatesChange(date)
		this.setState({
		
			endDate: date
		})

	}



	onStartTimeChange = (e) => {
			let startTime = e.target.value 
			let { endDate, endTime } = this.state;
			const { selectHour } = this.props;

			const hour = (startTime - (startTime % 60)) / 60;
			const min = startTime % 60;

			var startDate = moment(
				this.state.startDate
			).set({
				hour: hour,
				minute: min,
				second: 0,
				milliseconds: 0,
			});

			if (selectHour > 0) {
				endDate = getEndDatewd(selectHour, startDate);
				endTime = endDate.get('hour') * 60 + endDate.get('minute')
			}


			this.setState({
				startTime: startTime,
				startDate: startDate,
				endDate: endDate,
				endTime: endTime
			})
			
			this.props.onStartTimeChange(startTime)

			this.onCloseDropdown("isDropdownST")

		// }
 		
	}

	
	onEndTimeChange = (e) => {
			let endTime = e.target.value;
			const hour = (endTime - (endTime % 60)) / 60;
			const min = endTime % 60;

			var endDate = moment(
				this.state.endDate
			).set({
				hour: hour,
				minute: min,
				second: 0,
				milliseconds: 0,
			});

			this.setState({
				endTime: endTime,
				endDate: endDate
			})

			this.props.onEndTimeChange(endTime)
			this.onCloseDropdown("isDropdownET")
 	
	}
	  



     renderAvailDayContents = (day) => {
        
        return (
          <span className="holiday-dates">{moment(day).format("D")}</span>
        );
      };
    
	onFocusChange = (focused) => {

      
		this.setState({
			// Force the focusedInput to always be truthy so that dates are always selectable
			focused: focused.focused,
		  });
	}

    onFocusEDChange = (focused) => {

       
		this.setState({
			// Force the focusedInput to always be truthy so that dates are always selectable
			focusedED: focused.focused,
		  });
	}

	isOutsideRange = (day) => {
		const { minDate, maxDate } = this.state;
		return  day.isAfter(moment(maxDate).add(1, 'days')) || day.isBefore(moment(minDate).subtract(1, 'days'));
	}


    closeBox = () => {
        this.props.hideModal()
    }

	searchCar = () => {
		// const { filter } = this.props;
		// this.props.searchCar(filter);
		this.props.hideModal()
	}

	toggleDurationTimeBox = (isSelectHour) => {
		// const { isSelectHour } = this.state;
		this.props.toggleDurationTimeBox(isSelectHour)
		
	};

	onSelectHourChange = (e) => {
		this.props.onSelectHourChange(e);
	};

	getDayChildContent = (day) => {
		const obj = this.props.getDayChildContent(day)
	
		return <>
				{obj && obj.unavail ? obj.unavail() : null}
				{obj && obj.child ? obj.child() : null}
				{obj && obj.instant ? obj.instant() : null}
				{obj && obj.booking ? obj.booking() : null}
			</>
		
		
	}

    render() {
		const { show, finding, isMCalendar, selectHour, durationTimeArr, isSelectHour, filter }  = this.props; 
		const { endDate, startDate, startTime, endTime, isDropdownST, isDropdownET} = this.state;


		const defaultProps = {

			initialStartDate: moment(),
			initialEndDate: moment().add(1, "days"),

			// day presentation and interaction related props
			minimumNights: 1,
			isDayBlocked: () => false,
			isDayHighlighted: () => false,
			enableOutsideDays: false,
			daysViolatingMinNightsCanBeClicked: false,
		  
			// calendar presentation and interaction related props
			orientation: HORIZONTAL_ORIENTATION,
			verticalHeight: undefined,
			withPortal: false,
		
			numberOfMonths: 2,
			onOutsideClick() {},
			keepOpenOnDateSelect: false,
		
			isRTL: false,
			renderMonthText: null,
			renderMonthElement: null,
			renderKeyboardShortcutsButton: undefined,
			renderKeyboardShortcutsPanel: undefined,
		  
			// navigation related props
			navPrev: null,
			navNext: null,
			renderNavPrevButton: null,
			renderNavNextButton: null,
		
		  
			// internationalization
			monthFormat: 'MMMM YYYY',
		}
        return (
    <Modal
          show={show}
          onHide={this.closeBox}
          dialogClassName="modal-m modal-dialog modal-fix modal-search has-footer">
          <Modal.Header closeButton={true} closeLabel={""}>
           		<h5>Thời gian</h5>
          </Modal.Header>
          <Modal.Body>
              <div className="modal-confirm-body">
			 	 	<div className="time-choose" style={{marginBottom: "20px"}}>
					<div className="time-choose__item" >
                     <p className="title-time">Ngày bắt đầu</p>
                        <div className="active-time">
						{!isMCalendar ? 
                            <SingleDatePicker
                                {...defaultProps}
                                date={startDate}
                                focused={this.state.focused}
                                onDateChange={(date) => { this.onStartDateChange(date)}}
                                onFocusChange={this.onFocusChange}
                                orientation={'horizontal'}
                           
                                isOutsideRange={this.isOutsideRange}
								hideKeyboardShortcutsPanel={true}
                                readOnly={true}
								numberOfMonths={2}
                                initialVisibleMonth={() => moment()} 
								monthFormat="MMMM"
								renderDayContents={(day) => <p>{day.format('D')} {this.getDayChildContent(day)}</p>}
                            /> : 
								<SingleDatePicker
								{...defaultProps}
								date={startDate}
								focused={this.state.focused}
								onDateChange={(date) => { this.onStartDateChange(date)}}
								onFocusChange={this.onFocusChange}
								orientation={'vertical'}
								verticalHeight={ 450 }
								isOutsideRange={this.isOutsideRange}
								hideKeyboardShortcutsPanel={true}
								readOnly={true}
								navPrev={<><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none"><path transform="rotate(-180deg)" d="M17 9.17a1 1 0 00-1.41 0L12 12.71 8.46 9.17a1 1 0 10-1.41 1.42l4.24 4.24a.999.999 0 001.42 0L17 10.59a1 1 0 000-1.42z" fill="#000" /></svg></>}
								navNext={<><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none"><path d="M17 9.17a1 1 0 00-1.41 0L12 12.71 8.46 9.17a1 1 0 10-1.41 1.42l4.24 4.24a.999.999 0 001.42 0L17 10.59a1 1 0 000-1.42z" fill="#000" /></svg></>}
								onPrevMonthClick={() => {}}
								onNextMonthClick={(month) => {}}
								numberOfMonths={3}
								monthFormat="MMMM"
								initialVisibleMonth={() => moment()} 
								renderDayContents={(day) => <p>{day.format('D')} {this.getDayChildContent(day)}</p>}
							/>}
		
                        </div>
                    </div>

					
					<div className="time-choose__item" >
                
						<div onClick={() => isDropdownST ? this.onCloseDropdown('isDropdownST') : this.onHandleDropdown('isDropdownST')}>
								<p className="title-time">Đón xe lúc</p>
								<p className="active-time">{formatTime(startTime)}</p>
							</div>
							{isDropdownST && <div className="dropdown-time"> 
								{bookingTimes.map(time => <div className="custom-radio" id={`wst${time.value}`} key={`wst${time.id}`}> 
									<input type="radio" id={`rst${time.id}`} name={`r-startTime`} value={time.value} checked={startTime == time.value} onChange={this.onStartTimeChange}/>
									<label htmlFor={`rst${time.id}`}>{time.label}</label>
								</div>)}
							</div>}
						</div>
					</div>

					
					<div className={`time-choose ${selectHour !== 0 ? 'bottom' : ""}`} style={selectHour === 0 ? {marginBottom: '20px'} : null}>
                    	<div className="time-choose__item" ref={this.props.wrapperSelect}>
							<div  ref={this.props.wrapperSelect}>
								<p className="title-time">Thời gian thuê</p>

                                {selectHour > 0 ? (
                                    <p className="select active-time" onClick={() => this.toggleDurationTimeBox(isSelectHour)}>
                                        {convertToHourText(selectHour)} 
                                        <span className="font-12 text-gray">
                                            {" "} (kết thúc {getEndDatewd(selectHour, moment(startDate)).format("HH:mm DD/MM/YYYY")})
                                        </span>
                                    </p>
                                ) : (
                                    <p className="select active-time" onClick={() => this.toggleDurationTimeBox(isSelectHour)}>
                                        Tùy chỉnh
                                    </p>
                                )}
							</div>
							{isSelectHour && <div className="dropdown-time">
									{durationTimeArr &&
										durationTimeArr.map((time) => (
											<div className="custom-radio" key={time}>
												<input
													type="radio"
													id={`selectHour_${time}`}
													name="selectHour"
													checked={selectHour === time}
													value={time}
													onChange={this.onSelectHourChange}
												/>
												{" "}
												{time > 0 ? (
													<label htmlFor={`selectHour_${time}`}>
														{convertToHourText(time)}
														<span className="note-time">
															(kết thúc {getEndDatewd(time, moment(startDate)).format("HH:mm DD/MM/YYYY")})
														</span>
													</label>
												) : (
													<label htmlFor={`selectHour_${time}`}>Tùy chỉnh</label>
												)}
											</div>
										))}
                            </div>}

							
                    	</div>
					</div>

		
				
					{selectHour === 0 && <div className="time-choose bottom">
						<div className="time-choose__item" >
						<p className="title-time">Ngày kết thúc</p>
							<div className="active-time">
							{!isMCalendar ? 
                            <SingleDatePicker
                                {...defaultProps}
                                date={endDate}
                                focused={this.state.focusedED}
                                onDateChange={(date) => { this.onDatesChange(date)}}
                                onFocusChange={(focused) => this.onFocusEDChange(focused)}
                                orientation={'horizontal'}
                           
                                isOutsideRange={this.isOutsideRange}
								hideKeyboardShortcutsPanel={true}
                                readOnly={true}
								numberOfMonths={2}
                                initialVisibleMonth={() => moment()} 
								renderDayContents={(day) => <p>{day.format('D')} {this.getDayChildContent(day)}</p>}
                            /> : 
								<SingleDatePicker
								{...defaultProps}
								date={endDate}
								focused={this.state.focusedED}
								onDateChange={(date) => { this.onDatesChange(date)}}
								onFocusChange={(focused) => this.onFocusEDChange(focused)}
								orientation={'vertical'}
								verticalHeight={ 600 }
								isOutsideRange={this.isOutsideRange}
								hideKeyboardShortcutsPanel={true}
								readOnly={true}
								navPrev={<><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none"><path transform="rotate(-180deg)" d="M17 9.17a1 1 0 00-1.41 0L12 12.71 8.46 9.17a1 1 0 10-1.41 1.42l4.24 4.24a.999.999 0 001.42 0L17 10.59a1 1 0 000-1.42z" fill="#000" /></svg></>}
								navNext={<><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none"><path d="M17 9.17a1 1 0 00-1.41 0L12 12.71 8.46 9.17a1 1 0 10-1.41 1.42l4.24 4.24a.999.999 0 001.42 0L17 10.59a1 1 0 000-1.42z" fill="#000" /></svg></>}
								onPrevMonthClick={() => {}}
								onNextMonthClick={(month) => {}}
								numberOfMonths={3}
								initialVisibleMonth={() => moment()} 
								renderDayContents={(day) => <p>{day.format('D')} {this.getDayChildContent(day)}</p>}
							/>}
							
						
							</div>
						</div>
                   		<div className="time-choose__item" >
                
							<div onClick={() => isDropdownST ? this.onCloseDropdown('isDropdownET') : this.onHandleDropdown('isDropdownET')}>
									<p className="title-time">Trả xe lúc</p>
									<p className="active-time">{formatTime(endTime)}</p>
								</div>
								{isDropdownET && <div className="dropdown-time"> 
									{bookingTimes.map(time => <div className="custom-radio" id={`wet${time.value}`} key={`wet${time.id}`}> 
										<input type="radio" id={`rst${time.id}`} name={`r-startTime`} value={time.value} checked={endTime == time.value} onChange={this.onEndTimeChange}/>
										<label htmlFor={`rst${time.id}`}>{time.label}</label>
									</div>)}
								</div>}
							</div>
                		</div>}
               
                    
                
			
			 </div>
			 

          </Modal.Body>
			<Modal.Footer>
				<div className="info-time"> 
				<div className="info-time__item">
					<p className="time">{startTime ? `${formatTime(startTime)}` : 'Chọn giờ'} {startDate ? startDate.format('DD/MM') : "Chọn ngày bắt đầu"} - {endTime ? `${formatTime(endTime)}` : 'Chọn giờ'} {endDate ? endDate.format("DD/MM/YYYY") : 'Chọn ngày kết thúc'} </p>
					{selectHour > 0 &&  <p className="total">Thời gian thuê:   <span className="fontWeight-6">{convertToHourText(selectHour)}</span></p>}
				</div>
				<div className="wrap-btn"><a className="btn btn--s btn-primary" onClick={finding ? this.searchCar : this.closeBox} >Tiếp tục</a></div>
				</div>
			</Modal.Footer>
      	</Modal>
        )
    }


}

function mapState(state) {
	return {
		appInit: state.appInit
	};
}

CalendarWD = connect(mapState)(CalendarWD);

export default CalendarWD 